import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import IconButton from "../../../../components/IconButton";
import { IconLeftArrowVersion2 } from "../../../../icons";

export function TitleMobile({
  onClick,
  title,
  className,
  returnClick = true,
}: {
  onClick: () => void;
  title: string | ReactJSXElement;
  className?: string;
  returnClick?: boolean;
}) {
  return (
    <div className={`h-40 w-full flex items-center mt-4 ${className}`}>
      {returnClick ? (
        <IconButton
          icon={IconLeftArrowVersion2}
          onClick={onClick}
          className="flex items-center justify-center rounded-full border border-gray-800 shadow-2xl w-16 h-16"
        />
      ) : (
        ""
      )}
      <h1 className={`text-center font-familyPoppins text-4xl text-textPrimary font-bold ${!returnClick ? "w-full" : "w-4/5 "}`}>{title}</h1>
    </div>
  );
}
